import { Agent, Campaign, FacebookComment, FacebookPage, FacebookPost, FetchedAgent, FetchedCampaign } from "../../utils/interfaces"
import post1 from "../../assets/postComments/post1.json"
import post2 from "../../assets/postComments/post2.json"
import post3 from "../../assets/postComments/post3.json"
import PostCampaignCard from "./PostCampaignCard"
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Typography } from "@mui/material"
import CommentTable from "./TreeCommentTable"
import useFacebookSdk from "./Hooks/useFacebookSdk"
import { AMAZON_CAMPAIGN_ENDPOINTS2, EMPTY_CAMPAIGNs, FACEBOOK_APP_ID, FACEBOOK_POSTS } from "../../utils/constant"
import { useEffect, useState } from "react"
import { useFacebookLogin } from "./Hooks/useFacebookLogin"
import { useFetchPosts } from "./Hooks/useFacebookFetchPagePosts"
import CampaignDisplay from "./CampaignDisplay"
import IntroductionSection from "./IntroductionSectionCampaigns"
import { LogoutOptions } from "@auth0/auth0-spa-js"
import axios from "axios"
interface CampaignPageProp {
    userId: string
}
const CampaignPage = ({ userId }: CampaignPageProp) => {
    const [campaigns, setCampaigns] = useState<FetchedCampaign[]>([{name: "", campaign_id: ""}])
    const [selectedCampaign, setSelectedCampaigns] = useState<FetchedCampaign>({name: "", campaign_id: ""})
    const [selectedPageId, setSelectedPageId] = useState<string>('');
    const [agents, setAgents] = useState<FetchedAgent[]>([]);
    const [selectedAgent, setSelectedAgent] = useState<FetchedAgent>({name: "", agent_id: ""})

    const fetchCampaigns = async (userId: string) => {
        try {
            const response = await axios.get<FetchedCampaign[]>(`${AMAZON_CAMPAIGN_ENDPOINTS2}/campaigns/by-user/69ecf6d0-5c09-4371-aa58-8fef3d63cbcf`);
            setCampaigns(response.data);
        } catch (error) {
            console.error('Error fetching campaigns:', error);
        }}

    const fetchAgents = async (campaignId: string) => {
        try {
            const response = await axios.get<FetchedAgent[]>(`${AMAZON_CAMPAIGN_ENDPOINTS2}/agents/by_campagne/${campaignId}`);
            setAgents(response.data);
            console.log(response.data)
            setSelectedAgent(response.data[0])
        } catch (error) {
            console.error('Error fetching agents:', error);
        }
    };

    useEffect(() => {
        fetchCampaigns(userId);
        console.log(posts)
    }, [userId])

    useFacebookSdk(FACEBOOK_APP_ID)
    const { login, pages, isLoggedIn } = useFacebookLogin();
    const { fetchPosts, posts, isLoading } = useFetchPosts();

    const sendComment = async () => {
        window.FB.api('/me/accounts', 'GET', {}, function (pagesResponse: any) {
            if (pagesResponse && pagesResponse.data) {
                window.FB.api(
                    `/122098902860226747_7627186453979454/comments`,
                    'POST',
                    {
                        message: "second message",
                        access_token: pagesResponse.data[0].access_token
                    },
                    function (response: any) {
                        if (response && !response.error) {
                            console.log('Comment ID:', response.id);
                        } else {
                            console.error('Error:', response.error);
                        }
                    }
                );
            }
        })
    }

    useEffect(() => {
        if (selectedPageId !== '' && pages.length > 0) {
            const selectedPage = pages.find(page => page.id === selectedPageId);
            if (selectedPage) {
                fetchPosts(selectedPage.access_token, selectedPageId);
                console.log(posts)
            }
        }
    }, [selectedPageId]);
    const loggendInPlaceholder = true;

    const handlePageChange = (event: SelectChangeEvent<string>) => {
        setSelectedPageId(event.target.value as string);
    }


    return (
        <>
            <IntroductionSection isMobile={false} logout={function (options?: LogoutOptions | undefined): Promise<void> {
                throw new Error("Function not implemented.")
            }} setIsReportModalOpen={function (state: boolean): void {
                throw new Error("Function not implemented.")
            }} />
            <Stack direction={'column'} alignItems="center" sx={{ width: '100%' }}>

                {!loggendInPlaceholder && (
                    <Button sx={{ m: 2 }} variant="contained" onClick={login}>Login with Facebook</Button>
                )}
                <Stack sx={{ width: '80vw', minHeight: '150vh', background: '#f4f4f4', p: 2 }} direction={'column'}>
                    {loggendInPlaceholder && (
                        <Stack direction={'column'}>
                            <CampaignDisplay
                                setAgents={setAgents}
                                agents={agents}
                                fetchAgents={fetchAgents}
                                campaigns={campaigns}
                                setCampaigns={setCampaigns}
                                selectedCampaign={selectedCampaign}
                                setSelectedCampaign={setSelectedCampaigns}
                            />

                            <FormControl sx={{ width: '300px' }} margin="normal">

                                <InputLabel id="page-select-label">Select Page</InputLabel>
                                <Select
                                    labelId="page-select-label"
                                    id="page-select"
                                    value={selectedPageId}
                                    label="Select Page"
                                    onChange={handlePageChange}
                                >
                                    {pages.map((page: FacebookPage) => (
                                        <MenuItem key={page.id} value={page.id}>{page.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Stack>
                    )}
                    <Box>{
                        posts.map((post, index) => (
                            <Grid key={index} container spacing={2} style={{ justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

                                <Grid item xs={12} sm={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                    <PostCampaignCard url={post.url} />
                                </Grid>

                                <Grid item xs={12} sm={8} style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Typography sx={{
                                        fontSize: { xs: "10px", sm: '10px', md: "12px" },
                                    }} fontWeight={'bold'} variant="subtitle2">{`${post.comments.length} comments`}</Typography>

                                    <CommentTable campaignId={selectedCampaign.campaign_id} selectedAgent={selectedAgent} post={post} />
                                </Grid>
                            </Grid>
                        ))
                    }
                    </Box>
                </Stack>
            </Stack>
        </>

    )

}

export default CampaignPage